'use client';

import React, { createContext, useContext, useState } from 'react';
import { useIsMobile, useScrollLock } from '@/hooks';

export type MenuContextType = {
  isMobile: boolean;
  isMenuOpen: boolean;
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  popOverStates: Record<string, boolean>;
  toggleSideBar: () => void;
  togglePopOverMenu: (key: string) => void;
};

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const MenuProvider = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useIsMobile({ width: 1024 });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [popOverStates, setPopOverStates] = useState<Record<string, boolean>>(
    {},
  );

  useScrollLock(isMenuOpen && isMobile);

  const toggleSideBar = () => {
    setIsMenuOpen((isMenuOpen) => !isMenuOpen);
  };

  const togglePopOverMenu = (key: string) => {
    setPopOverStates((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <MenuContext.Provider
      value={{
        isMobile,
        isMenuOpen,
        setIsMenuOpen,
        popOverStates,
        toggleSideBar,
        togglePopOverMenu,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenuContext must be used within a MenuProvider');
  }
  return context;
};
